import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PdfDropService {
  private readonly openSubject = new Subject<void>();
  private readonly uploadedSubject = new Subject<string>();

  readonly open$ = this.openSubject.asObservable();
  readonly uploaded$ = this.uploadedSubject.asObservable();

  open(): void {
    this.openSubject.next();
  }

  uploaded(filename: string): void {
    this.uploadedSubject.next(filename);
  }
}
